import { render, staticRenderFns } from "./EGiftOrders.vue?vue&type=template&id=2ecb5736"
import script from "./EGiftOrders.vue?vue&type=script&lang=ts"
export * from "./EGiftOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports